export const normalizeId = (value: any): string | null => {
  if (value === null || value === undefined) return null;

  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }

  if (typeof value === "object") {
    const id = value._id ?? value.id ?? value.value ?? value.key;
    return id !== undefined && id !== null ? String(id) : null;
  }

  return null;
};

export const getRoleDashboardIds = (
  roleIds: any[] = [],
  rolesList: any[] = []
): string[] => {
  const selectedRoleIds = new Set(
    (roleIds || [])
      .map((id) => normalizeId(id))
      .filter((id): id is string => Boolean(id))
  );

  return Array.from(
    new Set(
      (rolesList || [])
        .filter((role: any) => selectedRoleIds.has(String(normalizeId(role) ?? role?._id ?? role?.id)))
        .flatMap((role: any) => role?.dashboards || [])
        .map((dashboardId: any) => normalizeId(dashboardId))
        .filter((dashboardId): dashboardId is string => Boolean(dashboardId))
    )
  );
};

export const resolveUserRoleObjects = (userRoles: any[] = [], rolesList: any[] = []) =>
  (userRoles || [])
    .map((role: any) => {
      const id = normalizeId(role) ?? role;
      const matchedRole = rolesList.find(
        (candidate: any) => String(normalizeId(candidate) ?? candidate?._id ?? candidate?.id) === String(id)
      );

      if (matchedRole && typeof role === "object") {
        return {
          ...role,
          ...matchedRole,
          _id: normalizeId(role) ?? normalizeId(matchedRole),
        };
      }

      if (matchedRole) {
        return matchedRole;
      }

      if (typeof role === "object") {
        return role;
      }

      return null;
    })
    .filter(Boolean);

export const getUserDashboardSelection = ({
  row,
  rolesList = [],
  dashboardsList = [],
}: {
  row: any;
  rolesList?: any[];
  dashboardsList?: any[];
}) => {
  const resolvedRoleObjects = resolveUserRoleObjects(row?.roles || [], rolesList);

  const originalUserDashboardIds: string[] = Array.from(
    new Set(
      (row?.dashboards || [])
        .map((dashboardId: any) => String(normalizeId(dashboardId) ?? dashboardId))
        .filter((dashboardId: string) =>
          (dashboardsList || []).some(
            (dashboard: any) => String(normalizeId(dashboard) ?? dashboard?._id ?? dashboard?.id) === dashboardId
          )
        )
    )
  );

  const selectedRoleIds: string[] = (resolvedRoleObjects || [])
    .map((role: any) => String(normalizeId(role) ?? role?._id ?? role?.id))
    .filter((roleId): roleId is string => Boolean(roleId));

  const roleDashboardIds: string[] = getRoleDashboardIds(selectedRoleIds, rolesList)
    .filter((dashboardId: string) =>
      (dashboardsList || []).some(
        (dashboard: any) => String(normalizeId(dashboard) ?? dashboard?._id ?? dashboard?.id) === dashboardId
      )
    );

  const roleDashboardSet = new Set<string>(roleDashboardIds);
  const baselineDirectDashboardIds: string[] = originalUserDashboardIds.filter(
    (dashboardId: string) => !roleDashboardSet.has(dashboardId)
  );

  const dashboardIds: string[] = Array.from(
    new Set([...baselineDirectDashboardIds, ...roleDashboardIds])
  );

  return {
    originalUserDashboardIds: baselineDirectDashboardIds,
    roleDashboardIds,
    dashboardIds,
  };
};
